/* Park Market — pixie dust easter egg.
   Flick the cursor fast enough and it sheds a brief trail of the
   brand's hand-drawn stars. Velocity-gated so normal browsing never
   triggers it; capped, pooled, desktop-pointer only, and silent for
   reduced-motion users. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  /* The full brand star wardrobe: every point count (4-8), filled and
     hollow, in the colors that read on cream and on the color bands.
     Built programmatically so the dust is never the same twice. */
  var STARS = (function () {
    var pts = ['4pt', '5pt', '6pt', '7pt', '8pt'];
    var colors = ['gold', 'pink', 'darkpink', 'orange', 'white', 'beige'];
    var out = [];
    pts.forEach(function (pt) {
      colors.forEach(function (c) {
        out.push('pm-star-' + pt + '-' + c + '.png');
        out.push('pm-star-' + pt + '-hollow-' + c + '.png');
      });
    });
    // The only combination with no asset file in the theme.
    return out.filter(function (n) { return n !== 'pm-star-4pt-hollow-beige.png'; });
  })();
  var base = document.currentScript && document.currentScript.src
    ? document.currentScript.src.replace(/pm-magic\.js.*$/, '')
    : '';
  if (!base) return;

  var VELOCITY_THRESHOLD = 28;  // px per frame-ish; a flick, not a browse
  var MAX_LIVE = 36;
  var SPAWN_EVERY_MS = 28;

  var live = 0, lastX = null, lastY = null, lastT = 0, lastSpawn = 0;

  var layer = document.createElement('div');
  layer.setAttribute('aria-hidden', 'true');
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden;';
  document.body.appendChild(layer);

  var style = document.createElement('style');
  style.textContent =
    '@keyframes pm-dust{' +
    'from{transform:translate(0,0) rotate(0) scale(1);opacity:0.95}' +
    'to{transform:translate(var(--dx),var(--dy)) rotate(var(--dr)) scale(0.35);opacity:0}}';
  document.head.appendChild(style);

  function spawn(x, y, vx, vy) {
    if (live >= MAX_LIVE) return;
    live++;
    var img = document.createElement('img');
    var s = 9 + Math.random() * 13;
    var dur = 700 + Math.random() * 700;
    img.src = base + STARS[(Math.random() * STARS.length) | 0];
    img.alt = '';
    img.style.cssText =
      'position:absolute;left:' + (x - s / 2) + 'px;top:' + (y - s / 2) + 'px;' +
      'width:' + s + 'px;height:' + s + 'px;' +
      '--dx:' + (-vx * 2 + (Math.random() - 0.5) * 70) + 'px;' +
      '--dy:' + (-vy * 2 + (Math.random() - 0.5) * 70 + 30) + 'px;' +
      '--dr:' + ((Math.random() - 0.5) * 240) + 'deg;' +
      'animation:pm-dust ' + dur + 'ms cubic-bezier(0.25,0.8,0.4,1) forwards;';
    img.addEventListener('animationend', function () {
      img.remove();
      live--;
    });
    layer.appendChild(img);
  }

  window.addEventListener('pointermove', function (e) {
    var t = performance.now();
    if (lastX !== null) {
      var dt = Math.max(t - lastT, 1);
      var vx = (e.clientX - lastX) / dt * 16;
      var vy = (e.clientY - lastY) / dt * 16;
      var speed = Math.hypot(vx, vy);
      if (speed > VELOCITY_THRESHOLD && t - lastSpawn > SPAWN_EVERY_MS) {
        lastSpawn = t;
        spawn(e.clientX, e.clientY, vx, vy);
        if (Math.random() < 0.5) spawn(e.clientX, e.clientY, vx, vy);
      }
    }
    lastX = e.clientX; lastY = e.clientY; lastT = t;
  }, { passive: true });
})();

/* ============================================================
   Charm lean — product tiles lean toward the cursor, like the plush
   noticed you reaching for it. Subtle (max ~7deg), springs back.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var MAX_DEG = 7;
  var raf = null;

  function findMedia(el) {
    var card = el.closest('.pm-card, .pm-treat');
    return card ? card.querySelector('.pm-card__media, .pm-treat__media') : null;
  }

  function clearLean(except) {
    document.querySelectorAll('.pm-lean').forEach(function (m) {
      if (m !== except) {
        m.classList.remove('pm-lean');
        m.style.transform = '';
      }
    });
  }

  document.addEventListener('pointermove', function (e) {
    var media = findMedia(e.target);
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      clearLean(media);
      if (!media) return;
      var r = media.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      media.classList.add('pm-lean');
      media.style.transform =
        'perspective(700px) rotateY(' + (dx * MAX_DEG).toFixed(2) + 'deg)' +
        ' rotateX(' + (-dy * MAX_DEG).toFixed(2) + 'deg)';
    });
  }, { passive: true });

  /* Snap back if the cursor leaves the page while over a card. */
  document.documentElement.addEventListener('mouseleave', function () {
    clearLean(null);
  });
})();

/* ============================================================
   Treat rain — type a treat's name anywhere and it rains.
   Hidden. Tell no one. Let them find it.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var FILES = 'https://cdn.shopify.com/s/files/1/0797/8346/1102/files/';
  var WORDS = {
    churro:   FILES + 'The_Churro.png',
    macaron:  FILES + 'The_Macaron.png',
    pretzel:  FILES + 'The_Pretzel.png',
    icecream: FILES + 'The_Ice_Cream_Bar.png'
  };
  var buffer = '';
  var raining = false;

  document.addEventListener('keydown', function (e) {
    if (e.target.matches('input, textarea, select, [contenteditable]')) return;
    if (e.key.length !== 1) return;
    buffer = (buffer + e.key.toLowerCase()).slice(-12);
    Object.keys(WORDS).forEach(function (word) {
      if (buffer.endsWith(word) && !raining) {
        buffer = '';
        rain(WORDS[word]);
      }
    });
  });

  function rain(src) {
    raining = true;
    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9998;overflow:hidden;';
    document.body.appendChild(layer);
    var n = 22;
    for (var i = 0; i < n; i++) {
      (function (i) {
        setTimeout(function () {
          var img = document.createElement('img');
          var s = 46 + Math.random() * 60;
          var x = Math.random() * 100;
          var dur = 1900 + Math.random() * 1300;
          var rot = (Math.random() - 0.5) * 520;
          img.src = src;
          img.alt = '';
          img.style.cssText =
            'position:absolute;left:' + x + 'vw;top:-140px;width:' + s + 'px;' +
            'transition:transform ' + dur + 'ms linear, opacity 400ms ease ' + (dur - 400) + 'ms;' +
            'will-change:transform;';
          layer.appendChild(img);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              img.style.transform = 'translateY(calc(100vh + 280px)) rotate(' + rot + 'deg)';
              img.style.opacity = '0.85';
            });
          });
        }, i * 80);
      })(i);
    }
    /* Last treat spawns at ~(n-1)*80ms and falls for up to 3200ms — keep the
       layer alive until the tail lands. */
    setTimeout(function () { layer.remove(); raining = false; }, n * 80 + 3600);
  }
})();

/* ============================================================
   The clip snap — on add-to-cart, the charm flies to the cart icon
   and clips on with a gold-ring snap. Fires on the pm:added event
   the PDP dispatches after a confirmed add.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  window.addEventListener('pm:added', function (e) {
    var cart = document.querySelector('.pm-header a[aria-label="Cart"]');
    var from = e.detail && e.detail.from;
    var src = e.detail && e.detail.image;
    if (!cart || !from || !src) return;
    var to = cart.getBoundingClientRect();

    var fly = document.createElement('img');
    fly.src = src;
    fly.alt = '';
    fly.style.cssText =
      'position:fixed;z-index:9999;pointer-events:none;' +
      'left:' + (from.left + from.width / 2 - 28) + 'px;top:' + (from.top - 20) + 'px;' +
      'width:56px;height:56px;object-fit:cover;border-radius:50%;' +
      'border:3px solid var(--pm-gold);box-shadow:0 6px 18px rgba(42,29,24,0.3);';
    document.body.appendChild(fly);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - from.top + 20;
    fly.animate([
      { transform: 'translate(0,0) scale(1)', offset: 0 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 120) + 'px) scale(0.7)', offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.18)', offset: 1 }
    ], { duration: 750, easing: 'cubic-bezier(0.3, 0.6, 0.4, 1)' }).onfinish = function () {
      fly.remove();
      cart.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.35) rotate(-8deg)' },
        { transform: 'scale(1)' }
      ], { duration: 360, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
    };
  });
})();
